import Typography from "./Typography";
import { spacing, borderRadius } from "../utils/tokens";
import { useTheme } from "../context/ThemeContext";

import { X, TrendUp, Sliders} from "@phosphor-icons/react";

import { useNavigate } from "react-router-dom";



function Modal({setIsModalOpen}){
        const navigate = useNavigate();
        const { theme } = useTheme();

        const openCreateWatchlist = () => {
            setIsModalOpen(false);  // Close modal
            navigate("/create-watchlist");  // Navigate to Create Watchlist
        };

        const styles={
            card:{
                cursor: "pointer",
                display: "flex",
                gap: spacing.m,
                border: "1px solid #EBEBEB",
                borderRadius: borderRadius.s,
                backgroundColor: theme.colors.fillPrimary,
                padding: spacing.m,
                alignItems: "flex-start",
                justifyContent: "flex-start",
            },
            cardText:{
                cursor: "pointer",
                display: "flex",
                gap: spacing.s,
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
            }
        }
    

    return (
        <div 
                        style={{ 
                            position: "fixed", 
                            bottom: 0, 
                            left: 0, 
                            width: "100%", 
                            height: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.3)", 
                            boxShadow: "0px -4px 10px rgba(0, 0, 0, 0.1)",
                            padding: spacing.xxxs,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-end",
                            zIndex: 9999,
                            
                        }}
                    >
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: 56, padding: "16px 16px", backgroundColor: theme.colors.fillPrimary, borderRadius: "8px 8px 0px 0px",
 }}>
                            <div 
                                style={{ opacity: 0, color: theme.colors.contentSecondary }} 
                            >
                                <X size={24} />
                            </div>
                            <Typography variant="headlineMedia" type="editorial">New Watchlist</Typography>
                            <div 
                                style={{ cursor: "pointer", color: theme.colors.contentSecondary }} 
                                onClick={() => setIsModalOpen(false)} // ✅ Close modal when clicked
                            >
                                <X size={24} />
                            </div>
                        </div>
                
                        {/* ✅ Watchlist Options */}
                        <div 
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: spacing.m,
                                padding: spacing.m,
                                paddingBottom: spacing.xl,
                                paddingTop: 0,
                                backgroundColor: theme.colors.fillPrimary,
                            }}
                        >
                            {/* Watchlist Option 1 */}
                            <div style={styles.card} onClick={openCreateWatchlist}>
                                <TrendUp size={24} style={{ flexShrink: 0 }}/>
                                <div style={styles.cardText}>
                                    <Typography variant="buttonALT" type="utility">Create a Watchlist</Typography>
                                    <Typography variant="supportingCaption" type="editorial" style={ {color: theme.colors.contentSecondary} }>
                                        Manually add and track selected stocks, and industries in one place.
                                    </Typography>
                                </div>
                            </div>

                
                            {/* Watchlist Option 2 */}
                            <div style={styles.card}>
                                <Sliders size={24} style={{ flexShrink: 0 }}/>
                                <div style={styles.cardText}>
                                    <Typography variant="buttonALT" type="utility">Create a Trend Watch</Typography>
                                    <Typography variant="supportingCaption" type="editorial" style={ {color: theme.colors.contentSecondary} }>
                                        Multiple search and sorting options, like price, sector, and market cap.
                                    </Typography>
                                </div>
                            </div>
                            
                        </div>
                        </div>
    )
}

export default Modal; 